// Archivos que se suben a una cotización (recibos en PDF o foto, PDF de FINSUS, fotos del sitio) y los que genera el
// cotizador (PDF de la propuesta, portada JPG, avisos, JSON v1). Los bytes viven en el AlmacenArchivos; aquí solo
// metadatos. NUNCA se expone la ruta en disco a la interfaz.
import { z } from 'zod';
import { FechaHora, Id, Medidor, Texto } from './basicos.ts';
import { BYTES_MAXIMOS_POR_ARCHIVO, TIPOS_ARCHIVO_ACEPTADOS } from '../constantes.ts';

export const TipoMime = z.enum([...TIPOS_ARCHIVO_ACEPTADOS, 'text/plain', 'application/json', 'text/html']);
export type TipoMime = z.infer<typeof TipoMime>;

export const ClaseArchivo = z.enum(['recibo', 'finsus', 'foto_sitio', 'otro', 'pdf_propuesta', 'portada_jpg', 'avisos_txt', 'json_v1', 'falla_html']);
export type ClaseArchivo = z.infer<typeof ClaseArchivo>;

export const ArchivoSubido = z.strictObject({
  id: Id,
  cotizacion_id: Id,
  /** A o B (solo recibos con dos medidores; el resto va en A). */
  medidor: Medidor,
  clase: ClaseArchivo,
  nombre_original: Texto(1, 200),
  tipo_mime: TipoMime,
  bytes: z.int().min(1).max(BYTES_MAXIMOS_POR_ARCHIVO * 2),
  sha256: z.string().regex(/^[a-f0-9]{64}$/),
  subido_por: Id,
  subido_en: FechaHora,
  /** Borrado lógico: el archivo sigue en el almacén y en el historial. */
  eliminado: z.boolean(),
});
export type ArchivoSubido = z.infer<typeof ArchivoSubido>;
